import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'reactstrap';
var containerStyle = {
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 1000
};
var spinnerStyle = {
  position: 'relative',
  margin: '10% 40%',
  zIndex: 1100,
  height: '10em',
  width: '10em'
};

/**
 * General Loader.
 */
var Loader = function Loader(props) {
  var isLoading = props.isLoading,
    color = props.color;
  return !isLoading ? null : /*#__PURE__*/React.createElement("div", {
    className: "diagLoaderContainer",
    style: containerStyle
  }, /*#__PURE__*/React.createElement(Spinner, {
    color: color,
    className: "diagLoaderSpinner",
    style: spinnerStyle
  }));
};
Loader.propTypes = {
  isLoading: PropTypes.bool,
  color: PropTypes.string
};
Loader.defaultProps = {
  color: 'primary',
  isLoading: false
};
export default Loader;